import instance from "../api-provider";
import { isAuthenticated } from "./auth";

export const viewProfile = async (payload) => {
  try {
    let response = await instance({
      url: `/member/viewProfile`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
      // {"uuid":"b8f3d375-e424-464a-8a11-52e34d079bb3"}
    });
    return response.data;
  } catch (error) {
    return "ERROR";
  }
};

export const memberInsurance = async (payload) => {
  try {
    let response = await instance({
      url: `/member/memberInsurance`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
      // {"uuid":"b8f3d375-e424-464a-8a11-52e34d079bb3"}
    });
    return response.data;
  } catch (error) {
    return "ERROR";
  }
};

export const getMedication = async (uuid) => {
  try {
    let response = await instance({
      url: `/medication/getMedication/`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        uuid: uuid,
        // {"uuid":"b8f3d375-e424-464a-8a11-52e34d079bb3"}
      },
      data: null,
    });
    return response.data;
  } catch (error) {
    return "ERROR";
  }
};

export const getAllergies = async (uuid) => {
  try {
    let response = await instance({
      url: `/allergies/getAllergies/`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        uuid: uuid,
      },
      data: null,
    });
    return response.data;
  } catch (error) {
    return "ERROR";
  }
};

export const getMemberImmunization = async (uuid) => {
  // for vaccination
  try {
    let response = await instance({
      url: `/immunization/getMemberImmunization/`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        uuid: uuid,
      },
      data: null,
    });
    return response.data;
  } catch (error) {
    return "ERROR";
  }
};

export const getFamilyHistory = async (uuid) => {
  try {
    let response = await instance({
      url: `/famHistory/getFamilyHistory/`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        uuid: uuid,
      },
      data: null,
    });
    return response.data;
  } catch (error) {
    return "ERROR";
  }
};

export const getMemberHospitalization = async (uuid) => {
  try {
    let response = await instance({
      url: `/hospitalization/getMemberHospitalization/`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        uuid: uuid,
      },
      data: null,
    });
    return response.data;
  } catch (error) {
    return "ERROR";
  }
};

export const getSurgery = async (uuid) => {
  try {
    let response = await instance({
      url: `/surgery/getSurgery/`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        uuid: uuid,
      },
      data: null,
    });
    return response.data;
  } catch (error) {
    return "ERROR";
  }
};

export const getBirthHistory = async (uuid) => {
  try {
    let response = await instance({
      url: `/birthHistory/getBirthHistory/`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        uuid: uuid,
      },
      data: null,
    });
    return response.data;
  } catch (error) {
    return "ERROR";
  }
};

export const medRecordList = async (memberUuid) => {
  try {
    const { uuid } = isAuthenticated();
    let response = await instance({
      url: `/medRecords/medRecordList/`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        uuid: memberUuid,
        requestorUUID: uuid,
      },
      data: null,
    });
    return response.data;
  } catch (error) {
    return "ERROR";
  }
};

export const pastVisits = async (consumeruuid) => {
  try {
    const { uuid, doctorData } = isAuthenticated();
    const payload = {
      uuid,
      consumeruuid,
      todaysDate: new Date(),
      npi: doctorData?.npi,
    };
    let response = await instance({
      url: `/appointment/getConsumerPastAppointmentsForProviderLocation`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    return "ERROR";
  }
};

export const downloadRecordFile = async (id, fileType, uuid) => {
  try {
    let response = await instance({
      url: `/medRecords/downloadFile/${id}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        uuid: uuid,
      },
    });
    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: fileType }),
    );
    window.open(
      url,
      "_blank",
      "location=yes,height=570,width=520,scrollbars=yes,status=yes",
    );
  } catch (error) {
    return "ERROR";
  }
};
